import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WhitespaceElementModel } from '../../api/ContentDeliveryApi.schemas';

@customElement('lindberg-whitespace')
export class Whitespace extends LitElement {
    static styles = css`
        :host{
            display: block;
            /* background-image: repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1) 20px, transparent 20px, transparent 40px); */
        }
        :host(.spacing-xs) { height: var(--space-50) }    
        :host(.spacing-s) { height: var(--space-100) }    
        :host(.spacing-m) { height: var(--space-150) }    
        :host(.spacing-l) { height: var(--space-200) }
        :host(.spacing-xl) { height: var(--space-300) }
        :host(.spacing-2xl) { height: var(--space-400) }
        :host(.spacing-3xl) { height: var(--space-500) }
        :host(.spacing-4xl) { height: var(--space-600) }`

    data!: { content: WhitespaceElementModel} 

    render() {        
        if(this.data.content.properties.size) this.classList.add(`spacing-${this.data.content.properties.size.toLowerCase()}`);
        return html``
    }
}    

declare global {
  interface HTMLElementTagNameMap {
    'lindberg-whitespace': Whitespace;
  }
}
